import {IconButton, styled} from "@mui/material";

interface AlignmentIconButtonProps {
    active?: boolean;
}

export const AlignmentIconButton = styled(IconButton, {shouldForwardProp: (propName) => (
    !['active'].includes(propName.toString())
    )})<AlignmentIconButtonProps>`
  border-radius: 2px !important;
  background-color: ${props => props.active ? 'rgba(0, 0, 0, 0.1) !important' : 'transparent'};
  margin-right: 5px !important;
`;

